/* eslint-disable no-undef */
// import { TencentCaptchaAppId } from '@/tools/content_setting.js';

// import Vue from 'vue';
const initTencentCaptcha = () => {
  return new Promise((resolve, reject) => {
    if (typeof window.TencentCaptcha !== 'function') {
      const URL = 'https://turing.captcha.qcloud.com/TCaptcha.js'
      const scriptHeat = document.createElement('script')
      scriptHeat.type = 'text/javascript'
      scriptHeat.src = URL
      document.body.appendChild(scriptHeat)
      scriptHeat.onload = () => {
        resolve({
          TencentCaptcha: window.TencentCaptcha
        })
      }
    } else {
      resolve({
        TencentCaptcha: window.TencentCaptcha
      })
    }
  })
}

export default {
  async install (Vue) {
  	// 这里的Appid是腾讯工作台配置
    const { TencentCaptcha } = await initTencentCaptcha()
    let Captcha = TencentCaptcha
    Vue.prototype.$Captcha = Captcha
  }
}
